module.exports = __webpack_public_path__ + "img/bwyewm.dc67f654.jpg";